import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { gqlClient } from '@/lib';
import type { QueryError } from '@/utils/errors';
import { createTemplateAccountExperiencesQueryKey } from '@/utils/queryKeys';
import type {
  EnableExperienceTemplateMutation,
  EnableExperienceTemplateMutationVariables,
} from './useEnableExperienceTemplate.generated';

const mutation = gql`
  mutation EnableExperienceTemplate($input: EnableExperienceTemplateInput!) {
    enableExperienceTemplate(input: $input) {
      id
    }
  }
`;

export const useEnableExperienceTemplate = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending, error, reset } = useMutation<
    EnableExperienceTemplateMutation,
    QueryError,
    EnableExperienceTemplateMutationVariables
  >({
    mutationFn: (variables) => gqlClient.request(mutation, variables),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: createTemplateAccountExperiencesQueryKey(),
      });
    },
  });

  return { enableExperienceTemplate: mutate, isPending, error, reset };
};
